"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateId = exports.default = void 0;
const generateId = genus => {
  return genus.replace(/\s+/g, '-').toLowerCase();
};
exports.generateId = generateId;
class EntryFormController {
  constructor() {
    this.defaultDataShape = {
      nameOrNum: null,
      employmentGrade: null,
      yearOfBirth: null,
      sex: null,
      specXFunc: null,
      showAllSpecXFunc: false,
      employmentLevel: null,
      employmentStatus: null,
      personalHolidays: null,
      illnessAccidentDoctor: null,
      militaryCivilService: null,
      maternityPaternityLeave: null,
      publicOffices: null,
      vocationalSchool: null,
      overUnderTime: null,
      yearlyPresenceTime: null,
      educationTraining: null,
      advertisingAcquisition: null,
      contest: null,
      managementLeadership: null,
      edvOperation: null,
      others: null,
      grossSalary: null,
      baseSalary: null,
      addBenefits: null,
      varBenefits: null,
      yearlyNominalTime: null,
      vacation: null,
      remarks: null,
      errors: {}
    };
  }
  getFormData(employee) {
    if (!employee?.employeeId && Object.keys(employee).length === 0) {
      return this.defaultDataShape;
    }
    let employeeForDisplay = {
      ...employee
    };
    return employeeForDisplay;
  }
  getFormErrors(employee) {
    const fullList = {
      ...this.defaultDataShape
    };
    const formErrors = {};
    Object.keys(fullList).map(prop => {
      if (employee?.hash && employee?.errors[prop]) {
        return formErrors[prop] = employee.errors[prop];
      }
      return formErrors[prop] = fullList[prop];
    });
    return formErrors;
  }
  isUndefinedOrNullOrEmptyString = val => {
    if (val === '') {
      return true;
    }
    // Double Equals. Check for undefined or null
    return val == null;
  };
}
var _default = exports.default = EntryFormController;